export const MONTHLY_SUBSCRIPTION_PRICE = 20
